import {
  DynamicModel,
  getDynamicModelComponent,
  useActions,
  useModels,
} from '@k3/core';
import { ModelAction } from '@k3/core/dist/src/lib/engine/actionEngine2/types';

export const useK3ModelAndAction = (
  modelKey: string,
  loadWithoutAction?: boolean
) => {
  const model = useModels()?.find((model) => model.key === modelKey);

  if (!model) {
    return {};
  }

  const actions = useActions();
  const modelAction = actions?.models.find(
    (modelAction) => modelAction.modelId === model?.id
  );

  if (!loadWithoutAction && !modelAction) {
    return {};
  }

  let component: DynamicModel['component'] | undefined;
  if (model.dynamicModelKey) {
    component = getDynamicModelComponent(
      model,
      modelAction ?? ({ modelId: model.id } as ModelAction)
    );
  }

  const modelWithoutKey = { ...model, key: '' };

  return { model: modelWithoutKey, modelAction, component };
};
